export enum AutoUploadedDocumentSubType {
  CLEARESTATE_EXECUTOR_GUIDE = 'other_clearestate_executor_guide',
  WILL_COMPANION_GUIDE = 'other_will_companion_guide'
}
